import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getDynamicSection } from '../../services'
import { DynamicSectionQueryKeys } from '@/modules/client-setting/keys'
import {
	GetDynamicSectionRequest,
	GetDynamicSectionResponse,
} from '@/modules/client-setting/type'

export default function useQueryGetDynamicSection(
	payload: GetDynamicSectionRequest,
	props?: UseBaseQueryOptions<GetDynamicSectionResponse>,
) {
	return useQuery({
		queryKey: [DynamicSectionQueryKeys.GetDynamicSection, payload],
		queryFn: () => getDynamicSection(payload),
		...props,
	})
}
